// 信箱登入 - 輸入驗證碼
import { useState, useRef, useEffect } from 'react';

const EmailLoginVerify = ({
    t,
    email,
    verifyCode,
    handleChangeCode,
    handleKeyDown,
    inputRefs,
    onVerifyCode,
    onSendCode,
    hintCode,
}) => {
    const timer = useRef(null);

    // 填滿六個數字才能送出
    const canSubmit = verifyCode.findIndex((v) => v === '') === -1;

    // 重新發送倒數
    const [countdown, setCountdown] = useState(59);

    // 倒數
    const handleCountdown = () => {
        try {
            timer.current = setInterval(() => {
                setCountdown((prev) => prev - 1);
            }, 1000);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (countdown === 0) clearInterval(timer.current);
    }, [countdown]);

    useEffect(() => {
        handleCountdown();
        return () => clearInterval(timer.current);
    }, []);

    return (
        <>
            <p className="text-h3 text-jblack">{t('CHECK_EMAIL')}</p>
            <p className="text-bd4n text-black7 opacity-[.8] mt-[12px] mb-[46px]">
                {t('SENT')}
                {email}
            </p>

            <p className="text-bd6b text-black">{t('INPUT_VERIFY')}</p>

            {/* 驗證碼輸入 */}
            <div className="flex gap-x-[7px] text-btn5b text-black [&>*]:w-[calc((100%-35px)/6)] mt-[42px] mb-[46px] mx-auto">
                {verifyCode.map((value, index) => (
                    <input
                        key={index}
                        ref={(el) => (inputRefs.current[index] = el)} // 儲存到 refs
                        type="text"
                        maxLength="1"
                        value={value}
                        disabled={
                            index > verifyCode.findIndex((v) => v === '') &&
                            !(index === verifyCode.length - 1 && verifyCode.every((v) => v !== ''))
                        } // 啟用當前框或最後一個框
                        onChange={(e) => handleChangeCode(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className={`text-center py-[16px] bg-transparent tabular-nums border-b-[2px] ${
                            value ? 'border-plum' : 'border-black2'
                        } caret-plum`}
                    />
                ))}
            </div>

            {hintCode && (
                <p className="text-btn2 mt-[-20px] text-red0 opacity-[.8]">{t('VERIFY_HINT')}</p>
            )}

            <button
                disabled={!canSubmit}
                className={`text-white w-full block mt-[22px] rounded-[40px] text-btn1 text-center trans p-[16px]
                ${canSubmit ? 'bg-vPurple' : 'bg-black2'}`}
                onClick={onVerifyCode}
            >
                {t('CONFIRM')}
            </button>

            {/* 重新發送倒數 */}
            <p className="mt-[30px] text-btn1 text-jblack opacity-[.8]">
                {t('NOT_RECEIVED')}
                <button
                    disabled={countdown > 0}
                    className="tabular-nums text-plum underline decoration-plum"
                    onClick={() => {
                        setCountdown(59);
                        onSendCode();
                        handleCountdown();
                    }}
                >
                    {t('RESEND')}
                    {countdown < 1 ? '' : `(${countdown})`}
                </button>
            </p>
        </>
    );
};

export default EmailLoginVerify;
